import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import Vant from 'vant'

import util from "@/assets/util"
import filters from "@/assets/filters"
import VuePrototype from "@/assets/VuePrototype"

import Page from '@/components/Page'

import 'vant/lib/index.css'
import "@/assets/project.scss"

window.Vue = Vue
window.util = util
Vue.config.productionTip = false
Vue.use(Vant)

import moment from 'moment'
Vue.prototype.$moment = moment

//Pinia
import {createPinia, PiniaVuePlugin } from "pinia"
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

//收集全局异常并记录日志
window.onerror = function (msg, url, row, col, error) {
	// console.log(arguments)
	// console.log("================")
	// console.log(window?.App?.$notice?.error)
	if (!error) error = ""
	if (msg === "401") {
		window?.App?.checkUnauth()
		return true
	}
	if (msg?.includes("cross-origin")) return true
	if (msg?.toString().trim() === 'ResizeObserver loop limit exceeded') {
		return true
	}
	if (window?.App?.$notice?.error) {
		const prefixs = ["Uncaught Error:"] //过滤掉一些浏览器加的报错前缀
		prefixs.forEach(prefix=>{
			if(msg.startsWith(prefix)){
				msg = msg.substring(prefix.length).trim()
			}
		})
		window.App.$notice.error(msg, url)
		return false
	}
	let err = JSON.stringify({
		message: msg,
		referer: url,
		row: row,
		col: col
	})
	let stack = error && error.stack ? error.stack : ""
	reportErr(err, stack)
	function reportErr (err) {
		const src = process.env.NODE_ENV === 'production'
			? `${App.publicPath}/meap/h5err/`
			: "/api/clientError"
		err = encodeURIComponent(err)
		stack = encodeURIComponent(stack)
		const script = document.createElement("script")
		script.type = "text/javascript"
		script.src = `${src}?q=${err}&s=${stack}`
		document.getElementsByTagName('HEAD').item(0).appendChild(script)
	}
}
Vue.config.errorHandler = function (error, vm, info) {
	if (error === "cancel") return false
	console.log(error, vm, info)
	if (typeof error === "string") {
		error = new Error(error)
	}
	window.onerror(error.message, error.name, error.lineno, error.colno, error)
	// throw error
}
//统一捕获promise的异常并抛到全局
window.addEventListener("unhandledrejection", function (e) {
	e.preventDefault()
	//如果是已知错误，则不处理
	const reason = e.detail?.reason || e.reason
	if (reason === "cancel") return true
	throw reason
})
window.addEventListener("uncaughtException", function (e) {
	e.preventDefault()
	throw e
})
// 判断微信环境
if (window.navigator.userAgent.includes("wxwork")) sessionStorage.setItem("wxwork", window.navigator.userAgent.includes("wxwork"))
async function start (){
	//全局变量表
	const ua = navigator.userAgent.toLowerCase()
	const globalDefs = window.globalDefs = {
		SYSTEM_DATE_FORMAT: "YYYY-MM-DD", //日期格式
		SYSTEM_DATETIME_FORMAT: "YYYY-MM-DD HH:mm:ss", //时间格式
		SYSTEM_DATE_FORMAT_SHORT: "MM-DD", //短日期格式
		SYSTEM_DATETIME_FORMAT_SHORT: "MM-DD HH:mm", //短时间格式
		SYSTEM_TIME_FORMAT: "HH:mm:ss", //单时间格式
		SYSTEM_TIME_FORMAT_SHORT: "HH:mm", //短单时间格式
	
		isInWebview: ua.includes("ccssoft"),
		isInWechat: ua.includes("wechat"),
		isAndroid: ua.includes('Android')
	}
	Object.keys(globalDefs).forEach(key=>{
		window[key] = globalDefs[key]
	})
	Vue.use(VuePrototype)
	Vue.use(filters)
	Vue.component("Page", Page)
	new Vue({
		router,
		pinia,
		render: (h) => h(App),
	}).$mount("#app")
}
start()